import { useEffect, useRef } from "react";

export function useLatestRef<T>(value: T): React.MutableRefObject<T> {
	const latestRef = useRef(value);
	useEffect(() => {
		latestRef.current = value;
	}, [value]);
	return latestRef;
}
